module.exports = __webpack_public_path__ + "static/media/empty-table.adab44d8.svg";